// Fixed page templates that are predefined and can be added to the page structure

import { DisabledEditabilitySettings } from '../common/constants'
import { ABOUT_US_PAGE_DESIGN } from '../custom/aboutUs'
import { HOME_CLASSIC_PAGE_DESIGN } from '../custom/homeClassic'
import { HOME_MODERN_PAGE_DESIGN } from '../custom/homeModern'
import { HOME_SMART_ENERGY_PAGE_DESIGN } from '../custom/homeSmartEnergy'
import { SOLAR_SERVICES_PAGE_DESIGN } from '../custom/solarServices'
import { TESTIMONIALS_PAGE_DESIGN } from '../custom/testimonials'
import { VIDEO_PAGE_DESIGN } from '../custom/video'

export enum OnlineFixedTemplateEnum {
  OnlineSystemPerformance = 'online_system-performance',
  OnlineHowYourSystemWorks = 'online_how-your-system-works',
  OnlineElectricityBillSavings = 'online_electricity-bill-savings',
  OnlineNetFinancialImpact = 'online_net-financial-impact',
  CustomAboutUs = 'custom_about-us',
  CustomTestimonials = 'custom_testimonials',
  CustomSolarServices = 'custom_solar-services',
  CustomVideo = 'custom_video',
  CustomHomeClassic = 'custom_home-classic',
  CustomHomeSmartEnergy = 'custom_home-smart-energy',
  CustomHomeModern = 'custom_home-modern',
}

export const AVAILABLE_FIXED_TEMPLATE_IDS: string[] = Object.values(OnlineFixedTemplateEnum)

export const ONLINE_FIXED_TEMPLATE_DESIGN: Record<OnlineFixedTemplateEnum, any> = {
  [OnlineFixedTemplateEnum.OnlineSystemPerformance]: {
    name: 'System Performance',
    frames: [
      {
        component: {
          type: 'wrapper',
          ...DisabledEditabilitySettings,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'systemperformancepage',
              type: 'SystemPerformancePage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'l6jpkxC2K6G0k7dN',
      },
    ],
    id: OnlineFixedTemplateEnum.OnlineSystemPerformance,
  },
  [OnlineFixedTemplateEnum.OnlineHowYourSystemWorks]: {
    name: 'How Your System Works',
    frames: [
      {
        component: {
          type: 'wrapper',
          ...DisabledEditabilitySettings,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'howyoursystemworkspage',
              type: 'HowYourSystemWorksPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'hysw001',
      },
    ],
    id: OnlineFixedTemplateEnum.OnlineHowYourSystemWorks,
  },
  [OnlineFixedTemplateEnum.OnlineElectricityBillSavings]: {
    name: 'Energy Bill Savings',
    frames: [
      {
        component: {
          type: 'wrapper',
          ...DisabledEditabilitySettings,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'electricitybillsavingspage',
              type: 'ElectricityBillSavingsPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'l6jpkxC2K6G0k7dNb',
      },
    ],
    id: OnlineFixedTemplateEnum.OnlineElectricityBillSavings,
  },
  [OnlineFixedTemplateEnum.OnlineNetFinancialImpact]: {
    name: 'Net Financial Impact',
    frames: [
      {
        component: {
          type: 'wrapper',
          ...DisabledEditabilitySettings,
          stylable: [
            'background',
            'background-color',
            'background-image',
            'background-repeat',
            'background-attachment',
            'background-position',
            'background-size',
          ],
          components: [
            {
              tagName: 'netfinancialimpactpage',
              type: 'NetFinancialImpactPage',
              attributes: {
                class: ['proposal-background'],
              },
            },
          ],
          head: {
            type: 'head',
          },
          docEl: {
            tagName: 'html',
          },
        },
        id: 'l6jpkxC2K6G0k7dNc',
      },
    ],
    id: OnlineFixedTemplateEnum.OnlineNetFinancialImpact,
  },
  [OnlineFixedTemplateEnum.CustomAboutUs]: ABOUT_US_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomTestimonials]: TESTIMONIALS_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomSolarServices]: SOLAR_SERVICES_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomVideo]: VIDEO_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomHomeClassic]: HOME_CLASSIC_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomHomeSmartEnergy]: HOME_SMART_ENERGY_PAGE_DESIGN,
  [OnlineFixedTemplateEnum.CustomHomeModern]: HOME_MODERN_PAGE_DESIGN,
}
